import { createFileRoute } from "@tanstack/react-router";

import { POST_LOGIN_REDIRECT_PATH } from "@/features/auth/constants/auth.constants";
import { FirstRun } from "@/features/onboarding/modules/first-run/first-run";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/onboarding/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.onboarding_crumb() }),
});

function RouteComponent() {
  const { redirect, checkout } = Route.useSearch();
  return <FirstRun redirectTo={redirect ?? POST_LOGIN_REDIRECT_PATH} checkout={checkout} />;
}
